/* ==========================================================================
   Hero — Run On
   Subtle entrance animation (fade + slide-up) as progressive enhancement.
   - Content is fully visible without JS: the hidden initial state is only
     applied once JS adds the `.hero-run-on--animate` class.
   - Respects prefers-reduced-motion (no hidden state, no transition).
   - Re-initializes on shopify:section:load for the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '.hero-run-on';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initOne(el) {
    if (!el || el.dataset.heroRunOnInit === 'true') return;
    el.dataset.heroRunOnInit = 'true';

    // No animation when reduced motion is preferred or IO is unavailable:
    // leave content in its default (visible) state.
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    el.classList.add('hero-run-on--animate');

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(el);
  }

  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: (re)initialize the reloaded section.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
